import { createContext } from 'react';

/**
 * Collects a page's head tags while it renders on the server.
 *
 * In the browser SEOHead writes to document.head from an effect, and effects
 * never run during server rendering. entry-server.jsx provides an object here
 * (`{ origin, head }`); SEOHead fills `head` while rendering, and the server
 * writes those tags into the HTML it sends. In the browser there is no
 * provider, the value is null, and SEOHead behaves exactly as before.
 */
export const SSRHeadContext = createContext(null);
